<p-dialog
  header="Alta Notbank (cuenta hijo)"
  [modal]="true"
  [(visible)]="visible"
  (visibleChange)="onVisibleChange($event)"
  [style]="{ width: '720px' }"
  [maximizable]="true"
  appendTo="body"
>
  <p class="p-text-secondary mb-3">
    Antes de operar en <strong>{{ currency }}</strong>, el cliente debe tener una
    cuenta hijo en Notbank con documento del país. Completa el registro reliance
    (KYC CaaS).
  </p>

  <p class="p-text-secondary mb-3" *ngIf="errorMessage">
    {{ errorMessage }}
  </p>

  <p class="missing-hint mb-3" *ngIf="missingFields?.length">
    Campos pendientes:
    <strong>{{ missingFields.join(', ') }}</strong>
  </p>

  <form [formGroup]="form" class="provision-form" *ngIf="form">
    <div class="form-grid">
      <div class="form-item" [class.is-missing]="isMissing('first_name')">
        <label>Nombre <span class="required">*</span></label>
        <input pInputText formControlName="first_name" class="w-full" />
      </div>
      <div class="form-item" [class.is-missing]="isMissing('last_name')">
        <label>Apellido <span class="required">*</span></label>
        <input pInputText formControlName="last_name" class="w-full" />
      </div>

      <div class="form-item" [class.is-missing]="isMissing('phone_number')">
        <label>Teléfono E.164 <span class="required">*</span></label>
        <input
          pInputText
          formControlName="phone_number"
          class="w-full"
          placeholder="+5511999999999"
        />
      </div>
      <div class="form-item" [class.is-missing]="isMissing('profession')">
        <label>Profesión <span class="required">*</span></label>
        <input pInputText formControlName="profession" class="w-full" />
      </div>

      <div class="form-item" [class.is-missing]="isMissing('gender')">
        <label>Género <span class="required">*</span></label>
        <p-dropdown
          formControlName="gender"
          [options]="genderOptions"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          styleClass="w-full"
        />
      </div>
      <div class="form-item" [class.is-missing]="isMissing('birthdate')">
        <label>Nacimiento (DD/MM/YYYY) <span class="required">*</span></label>
        <input
          pInputText
          formControlName="birthdate"
          class="w-full"
          placeholder="15/03/1990"
        />
      </div>

      <div class="form-item" [class.is-missing]="isMissing('identity_type')">
        <label>Tipo documento <span class="required">*</span></label>
        <p-dropdown
          formControlName="identity_type"
          [options]="identityTypeOptions"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          styleClass="w-full"
        />
      </div>
      <div class="form-item" [class.is-missing]="isMissing('identity_number')">
        <label>Número documento <span class="required">*</span></label>
        <input pInputText formControlName="identity_number" class="w-full" />
      </div>

      <div class="form-item" [class.is-missing]="isMissing('citizenship')">
        <label>Nacionalidad ISO <span class="required">*</span></label>
        <input pInputText formControlName="citizenship" class="w-full" />
      </div>
      <div class="form-item" [class.is-missing]="isMissing('identity_country')">
        <label>País documento ISO <span class="required">*</span></label>
        <input pInputText formControlName="identity_country" class="w-full" />
      </div>

      <div class="form-item" [class.is-missing]="isMissing('address_country')">
        <label>País domicilio ISO <span class="required">*</span></label>
        <input pInputText formControlName="address_country" class="w-full" />
      </div>
      <div class="form-item" [class.is-missing]="isMissing('address_city')">
        <label>Ciudad <span class="required">*</span></label>
        <input pInputText formControlName="address_city" class="w-full" />
      </div>

      <div class="form-item full" [class.is-missing]="isMissing('address_street')">
        <label>Calle / dirección <span class="required">*</span></label>
        <input pInputText formControlName="address_street" class="w-full" />
      </div>
      <div class="form-item" [class.is-missing]="isMissing('address_postal_code')">
        <label>Código postal <span class="required">*</span></label>
        <input pInputText formControlName="address_postal_code" class="w-full" />
      </div>

      <!-- Country extras -->
      <div
        class="form-item"
        *ngIf="country === 'CL'"
        [class.is-missing]="isMissing('address_comune')"
      >
        <label>Comuna <span class="required">*</span></label>
        <input pInputText formControlName="address_comune" class="w-full" />
      </div>

      <ng-container *ngIf="country === 'BR'">
        <div class="form-item" [class.is-missing]="isMissing('address_district')">
          <label>Barrio / distrito <span class="required">*</span></label>
          <input pInputText formControlName="address_district" class="w-full" />
        </div>
        <div class="form-item" [class.is-missing]="isMissing('address_number')">
          <label>Número puerta <span class="required">*</span></label>
          <input pInputText formControlName="address_number" class="w-full" />
        </div>
        <div class="form-item" [class.is-missing]="isMissing('address_state')">
          <label>Estado (UF) <span class="required">*</span></label>
          <input
            pInputText
            formControlName="address_state"
            class="w-full"
            placeholder="SP"
          />
        </div>
      </ng-container>

      <ng-container *ngIf="country === 'AR'">
        <div class="form-item" [class.is-missing]="isMissing('address_province')">
          <label>Provincia <span class="required">*</span></label>
          <input pInputText formControlName="address_province" class="w-full" />
        </div>
        <div class="form-item checkbox-item">
          <label>
            <input type="checkbox" formControlName="subject_comply" />
            Sujeto obligado / comply
          </label>
        </div>
      </ng-container>

      <ng-container *ngIf="country === 'PE'">
        <div class="form-item" [class.is-missing]="isMissing('civil_status')">
          <label>Estado civil <span class="required">*</span></label>
          <p-dropdown
            formControlName="civil_status"
            [options]="civilStatusOptions"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            styleClass="w-full"
          />
        </div>
        <div class="form-item checkbox-item">
          <label>
            <input type="checkbox" formControlName="pep" />
            Persona expuesta políticamente (PEP)
          </label>
        </div>
        <ng-container *ngIf="form.get('pep')?.value">
          <div class="form-item" [class.is-missing]="isMissing('pep_position')">
            <label>Cargo PEP <span class="required">*</span></label>
            <input pInputText formControlName="pep_position" class="w-full" />
          </div>
          <div class="form-item" [class.is-missing]="isMissing('pep_institution')">
            <label>Institución PEP <span class="required">*</span></label>
            <input pInputText formControlName="pep_institution" class="w-full" />
          </div>
        </ng-container>
      </ng-container>
    </div>

    <p class="p-text-secondary mt-2" *ngIf="bankAccount">
      Se enviará también la cuenta bancaria / PIX ya cargada en el formulario.
    </p>
  </form>

  <ng-template pTemplate="footer">
    <p-button
      label="Cancelar"
      severity="danger"
      [disabled]="submitting"
      (click)="close()"
    />
    <p-button
      [label]="submitting ? 'Provisionando…' : 'Provisionar hijo'"
      severity="secondary"
      [loading]="submitting"
      [disabled]="submitting"
      (click)="submit()"
    />
  </ng-template>
</p-dialog>
